import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import StepArrowIcon from 'src/assets/img/step-arrow-icon.svg';
import { ZendeskIntegrationForm1 } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm1/ZendeskIntegrationForm1';
import { ZendeskIntegrationForm2 } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/ZendeskIntegrationForm2';

export const CreateZendeskIntegrationPopup = ({
  trigger,
  closeSourceModal = () => {},
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [zendeskIntegrationType, setZendeskIntegrationType] = useState('Help Center'); // ['Help Center', 'Tickets']
  const close = (shouldCloseSourceModal = false) => {
    setStep(0);
    setOpen(false);
    shouldCloseSourceModal && closeSourceModal();
  };

  const nextStep = (data) => {
    if (step === 0) {
      setZendeskIntegrationType(data.zendeskIntegrationType);
    }

    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger
          disabled={disabled}
          asChild
          className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
        >
          {trigger}
        </DialogTrigger>
        <DialogContent closeButtonHidden>
          <DialogHeader className={'flex-row items-center justify-between space-y-0 px-4'}>
            <DialogTitle className={'text-lg font-bold text-ebony_opacity_80'}>
              Zendesk Integration
            </DialogTitle>
            <p className={'flex items-center gap-[5px] text-xs font-medium text-ebony opacity-30'}>
              Step {step + 1} of 2
              {step === 0 && (
                <img src={StepArrowIcon} alt={''} width={9} height={9} className={'rotate-90'} />
              )}
            </p>
          </DialogHeader>
          <div className="grid gap-4">
            <div className="content min-h-[510px]">
              {step === 0 && (
                <ZendeskIntegrationForm1
                  zendeskIntegrationType={zendeskIntegrationType}
                  nextStep={nextStep}
                  closePopup={close}
                />
              )}
              {step === 1 && (
                <ZendeskIntegrationForm2
                  zendeskIntegrationType={zendeskIntegrationType}
                  prevStep={prevStep}
                  closePopup={close}
                />
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
